import React, { FC, MouseEventHandler } from 'react'

import { WithDataName } from 'common/types'
import { Colors } from 'common-constants/colors'

export const AddToFavoritesSvg: FC<
  {
    size?: number
    onClick?: MouseEventHandler<SVGSVGElement>
    strokeColor?: string
    ariaRole?: string
    tabIndex?: number
    fill?: string
  } & WithDataName
> = ({
  size = 14,
  onClick,
  strokeColor = Colors.link,
  fill = Colors.white,
  ariaRole,
  tabIndex,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 50 50"
    data-name={rest['data-name']}
    onClick={onClick}
    role={ariaRole}
    tabIndex={tabIndex}
  >
    <path
      fill={fill}
      fillRule="evenodd"
      stroke={strokeColor}
      strokeWidth="3"
      d="M25 40.8L9.55 49l2.95-17.367L0 19.334l17.275-2.533L25 1l7.725 15.8L50 19.335l-12.5 12.3L40.45 49z"
    />
  </svg>
)
